module.exports = __webpack_public_path__ + "static/media/school-default.995f0fd4.svg";